import { HEALTH_WEEK_CONSENT } from './constants';
import fetchWithRefresh from './fetchWithRefresh';
import { HealthWeekConsent } from './getHealthWeekConsent';

export default (profile: HealthWeekConsent): Promise<{ success: boolean }> => {
    return fetchWithRefresh(HEALTH_WEEK_CONSENT, {
        method: 'POST',
        body: JSON.stringify(profile),
        headers: {
            'Content-type': 'application/json',
        },
    }).then((res) => res.json());
};
